export default __webpack_public_path__ + "static/media/image01.7091c0ac.jpg";